import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { HideAllPricesModeState } from "@store/Store/Data/HideAllPricesMode/HideAllPricesModeState";
import { Draft } from "immer";

const initialState: HideAllPricesModeState = {};

const reducer = {
    "Store/Data/HideAllPricesMode/SetHideAllPricesModeStatus": (draft: Draft<HideAllPricesModeState>, action: { activated: boolean }) => {
        draft.activated = action.activated;
    },
    "Store/Data/HideAllPricesMode/ActivateHideAllPricesMode": (
        draft: Draft<HideAllPricesModeState>,
        action: { isHideAllPricesModeOn: boolean },
    ) => {
        draft.isHideAllPricesModeOn = action.isHideAllPricesModeOn;
    },
};

const hideAllPricesModeReducer = createTypedReducerWithImmer(initialState, reducer);
export default hideAllPricesModeReducer;
